<template>
	<v-layout column align-center class="content-pad-vert">
		<v-flex x12 sm10 md8 offset-sm-1 offset-md-2 class="pt-5">
			<div class="pl-3 pr-3">
				<h2 class="mb-4">What is WRKPRTY?</h2>
				<p>WRKPRTY is a platform that enables home-based and remote workers to host or attend a social co-working event (a “work party”) any place, any time.</p>
				
				<p>Reserve a seat in one-click on your phone, show up, be introduced, and work alongside a small group of dynamic professionals to maximize your productivity, be inspired, network, make friends, share, and collaborate.</p>

				<p>Best of all, you get real life high-fives (not just emojis) for all the awesome you do.</p>

				<p>WRKPRTY is for professional consultants, employees, entrepreneurs, freelancers, even those “between jobs”; anyone conducting business via laptop computer.</p>

				<p>It’s time to celebrate, PRTYPPL ... work is fun (again)!</p>

				<p>Have a question? <a @click="setModalOpen({prop:'contactForm', value: true})">Contact Us!</a></p>

				<p>Thanks for your support! We look forward to meeting you.</p>

				<p>
					Aidan Makepeace<br>
					Founder @ wrkprty
				</p>
			</div>
		</v-flex>
	</v-layout>
</template>

<script>
import { mapActions } from 'vuex'
export default {
	name: 'aboutus',
	methods: {
		...mapActions(['setModalOpen'])
	}
}
</script>
